(function ($) {
    $(function () {
    $(window).on('load',function () {
        setTimeout(function () {
            $(".resource-grid .slider").css({"opacity":"1"});
            $(".resource-grid .content-wrap").css({"opacity":"1"});
        },500);
        if($('.resource-grid, .slider').length>3) {
        }
            $('.resource-grid').each(function () {
                var item = $(this).find('.card-item');
                if (item.length > 3) {
                    $(this).find('.slider').slick({
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        arrow: false,
                        dots: true,
                        speed: 500,
                        autoplay: false,
                        infinite: false,
                        responsive: [
                            {
                                breakpoint: 1199,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,

                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,

                                }
                            },
                            {
                                breakpoint: 596,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    adaptiveHeight: true
                                }
                            },
                        ]
                    });

                }
            });
        });
    });
})(jQuery);



